// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { Vehicle } from "../models/Vehicle";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type WishlistDestroyData = Vehicle;

/** Params the client supplies at subscribe time. */
export type WishlistDestroyParams = Record<string, never>;

export class WishlistDestroyChannel extends Channel<WishlistDestroyParams, WishlistDestroyData> {
  static identifier = "WishlistDestroyChannel";
}
